export default "__VITE_ASSET__BXtgHBAB__"